import React from "react";
import { GroupTvProduct } from "PriceMonitoring/modal";
import { Row } from "antd";

import {
  ColRightAlign,
  HeadrCol,
  MainCol,
  StyledRow,
  Link,
} from "./styled";
import wb from "./wb.png";
import ozon from "./ozon.png";

const GroupItem = (props: { data: GroupTvProduct; queries: string[] }) => {
  const { data, queries } = props;
  return (
    <StyledRow internal={false}>
      <Row gutter={[6, 12]}>
        <HeadrCol span={10}>
          <Link href={data.link} target="_blank" rel="noreferrer">
            {data.name}
          </Link>
        </HeadrCol>
        <MainCol span={2}>
          <img
            src={
              data.link.match(/ozon/)
                ? ozon
                : data.link.match(/wildberries/)
                ? wb
                : undefined
            }
            alt=""
            style={{ height: 16 }}
          />
        </MainCol>
        <ColRightAlign span={4}>
          {data.price != null ? data.price : "–"}
        </ColRightAlign>
        <ColRightAlign span={4}>
          {data.unit_price != null ? data.unit_price : "–"}
        </ColRightAlign>
        {data.query_places.map((pos, i) => (
          <ColRightAlign
            span={Math.max(1, Math.floor(4 / queries.length))}
            key={i}
          >
            {pos != null ? pos : "–"}
          </ColRightAlign>
        ))}
      </Row>
    </StyledRow>
  );
};
export default GroupItem;
